//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./todo.d.ts" />

import * as $ from "skir-client";
import * as x_crm from "./crm.js";

// -----------------------------------------------------------------------------
// enum TodoPriority
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class TodoPriority extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum TodoCategory
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class TodoCategory extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum TodoStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class TodoStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum ExecutionAction
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class ExecutionAction extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum TodoUpdateSource
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class TodoUpdateSource extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct EmailDraftPayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `EmailDraftPayload.Mutable`. */
export class EmailDraftPayload extends $._FrozenBase {}

function initEmailDraftPayload(target, initializer) {
  target.to = $._toFrozenArray(
    initializer.to || []);
    target.cc = $._toFrozenArray(
      initializer.cc || []);
      target.subject = initializer.subject ?? "";
      target.body = initializer.body ?? "";
      target.contextSummary = initializer.contextSummary ?? "";
}

// -----------------------------------------------------------------------------
// struct SlackMessagePayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SlackMessagePayload.Mutable`. */
export class SlackMessagePayload extends $._FrozenBase {}

function initSlackMessagePayload(target, initializer) {
  target.recipient = initializer.recipient ?? "";
  target.messageText = initializer.messageText ?? "";
  target.urgency = initializer.urgency ?? "";
}

// -----------------------------------------------------------------------------
// enum CrmUpdateApplyOutcome
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmUpdateApplyOutcome extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct CrmUpdatePayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmUpdatePayload.Mutable`. */
export class CrmUpdatePayload extends $._FrozenBase {}

function initCrmUpdatePayload(target, initializer) {
  target.entityType = initializer.entityType ?? "";
  target.entityId = initializer.entityId ?? "";
  target.entityName = initializer.entityName ?? "";
  target.fieldUpdatesJson = initializer.fieldUpdatesJson ?? "";
  target.rationale = initializer.rationale ?? "";
  target.apiSlug = initializer.apiSlug ?? "";
  target.previousValue = initializer.previousValue ?? "";
  target.fieldName = initializer.fieldName ?? "";
  target.fieldType = initializer.fieldType ?? "";
  target.choicesJson = initializer.choicesJson ?? "";
  target.instructions = initializer.instructions ?? "";
  target.writeMode = x_crm.CustomFieldWriteMode.create(initializer.writeMode ?? x_crm.CustomFieldWriteMode.UNKNOWN);
  target.confidence = initializer.confidence ?? null;
  target.sourceType = initializer.sourceType ?? "";
  target.sourceId = initializer.sourceId ?? "";
  target.sourceLabel = initializer.sourceLabel ?? "";
  target.evidenceExcerpt = initializer.evidenceExcerpt ?? "";
  target.appliedAt = initializer.appliedAt ?? null;
  target.appliedBy = initializer.appliedBy ?? "";
  target.appliedValue = initializer.appliedValue ?? "";
  target.discardedAt = initializer.discardedAt ?? null;
  target.discardedBy = initializer.discardedBy ?? "";
  target.sourceDate = initializer.sourceDate ?? null;
  target.supersededAt = initializer.supersededAt ?? null;
}

// -----------------------------------------------------------------------------
// struct MeetingProposalPayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingProposalPayload.Mutable`. */
export class MeetingProposalPayload extends $._FrozenBase {}

function initMeetingProposalPayload(target, initializer) {
  target.participants = $._toFrozenArray(
    initializer.participants || []);
    target.suggestedSlots = $._toFrozenArray(
      initializer.suggestedSlots || []);
      target.durationMinutes = initializer.durationMinutes ?? 0;
      target.schedulingLink = initializer.schedulingLink ?? "";
      target.availabilitySummary = initializer.availabilitySummary ?? "";
}

// -----------------------------------------------------------------------------
// struct DocumentReferencePayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `DocumentReferencePayload.Mutable`. */
export class DocumentReferencePayload extends $._FrozenBase {}

function initDocumentReferencePayload(target, initializer) {
  target.docTitle = initializer.docTitle ?? "";
  target.docUrl = initializer.docUrl ?? "";
  target.relevantExcerpt = initializer.relevantExcerpt ?? "";
  target.whyRelevant = initializer.whyRelevant ?? "";
}

// -----------------------------------------------------------------------------
// struct SubTaskPayload
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `SubTaskPayload.Mutable`. */
export class SubTaskPayload extends $._FrozenBase {}

function initSubTaskPayload(target, initializer) {
  target.title = initializer.title ?? "";
  target.description = initializer.description ?? "";
  target.priority = initializer.priority ?? "";
  target.category = initializer.category ?? "";
  target.deadline = initializer.deadline ?? null;
}

// -----------------------------------------------------------------------------
// enum SuggestedAction
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SuggestedAction extends $._EnumBase {}

function createValueOfSuggestedAction(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "email_draft": {
      return EmailDraftPayload.create(value);
    }
    case "slack_message": {
      return SlackMessagePayload.create(value);
    }
    case "crm_update": {
      return CrmUpdatePayload.create(value);
    }
    case "meeting_proposal": {
      return MeetingProposalPayload.create(value);
    }
    case "document_reference": {
      return DocumentReferencePayload.create(value);
    }
    case "sub_task": {
      return SubTaskPayload.create(value);
    }
  }
}

// -----------------------------------------------------------------------------
// struct TodoSnapshot
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `TodoSnapshot.Mutable`. */
export class TodoSnapshot extends $._FrozenBase {}

function initTodoSnapshot(target, initializer) {
  target.id = initializer.id ?? "";
  target.title = initializer.title ?? "";
  target.description = initializer.description ?? "";
  target.priority = TodoPriority.create(initializer.priority ?? TodoPriority.UNKNOWN);
  target.category = TodoCategory.create(initializer.category ?? TodoCategory.UNKNOWN);
  target.status = TodoStatus.create(initializer.status ?? TodoStatus.UNKNOWN);
  target.deadline = initializer.deadline ?? null;
  target.confidence = initializer.confidence ?? 0;
  target.sourceEventType = initializer.sourceEventType ?? "";
  target.sourceEventId = initializer.sourceEventId ?? "";
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
  target.executionAction = ExecutionAction.create(initializer.executionAction ?? ExecutionAction.UNKNOWN);
  target.executionDetails = initializer.executionDetails ?? "";
  target.suggestedActions = $._toFrozenArray(
    initializer.suggestedActions || [],
    SuggestedAction.create,
  );
  target.reasoning = initializer.reasoning ?? "";
  target.parentTodoId = initializer.parentTodoId ?? "";
  target.crmAccountId = initializer.crmAccountId ?? null;
  target.crmAccountName = initializer.crmAccountName ?? "";
  target.crmAccountDomain = initializer.crmAccountDomain ?? "";
  target.crmOpportunityId = initializer.crmOpportunityId ?? null;
  target.crmOpportunityName = initializer.crmOpportunityName ?? "";
  target.relatedMeetingId = initializer.relatedMeetingId ?? "";
  target.relatedContactEmail = initializer.relatedContactEmail ?? "";
  target.relatedOpportunityRemoteId = initializer.relatedOpportunityRemoteId ?? "";
  target.assigneeUserId = initializer.assigneeUserId ?? "";
  target.ownerUserId = initializer.ownerUserId ?? "";
  target.crmContactId = initializer.crmContactId ?? null;
  target.crmContactName = initializer.crmContactName ?? "";
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "todo.skir",
  [
    {
      kind: "enum",
      ctor: TodoPriority,
      name: "TodoPriority",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "HIGH",
          number: 1,
        },
        {
          name: "MEDIUM",
          number: 2,
        },
        {
          name: "LOW",
          number: 3,
        },
      ],
    },
    {
      kind: "enum",
      ctor: TodoCategory,
      name: "TodoCategory",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "FOLLOW_UP",
          number: 1,
        },
        {
          name: "PREPARATION",
          number: 2,
        },
        {
          name: "DEAL_ACTION",
          number: 3,
        },
        {
          name: "INTERNAL",
          number: 4,
        },
        {
          name: "ADMINISTRATIVE",
          number: 5,
        },
      ],
    },
    {
      kind: "enum",
      ctor: TodoStatus,
      name: "TodoStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "OPEN",
          number: 1,
        },
        {
          name: "COMPLETED",
          number: 2,
        },
        {
          name: "DISMISSED",
          number: 3,
        },
      ],
    },
    {
      kind: "enum",
      ctor: ExecutionAction,
      name: "ExecutionAction",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "NONE",
          number: 1,
        },
        {
          name: "ENRICHED",
          number: 2,
        },
        {
          name: "EXECUTED",
          number: 3,
        },
        {
          name: "SKIPPED",
          number: 4,
        },
      ],
    },
    {
      kind: "enum",
      ctor: TodoUpdateSource,
      name: "TodoUpdateSource",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "DISCOVERY",
          number: 1,
        },
        {
          name: "EXECUTOR",
          number: 2,
        },
        {
          name: "MANUAL",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: EmailDraftPayload,
      initFn: initEmailDraftPayload,
      name: "EmailDraftPayload",
      fields: [
        {
          name: "to",
          property: "to",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableTo",
        },
        {
          name: "cc",
          property: "cc",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCc",
        },
        {
          name: "subject",
          property: "subject",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "body",
          property: "body",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "context_summary",
          property: "contextSummary",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SlackMessagePayload,
      initFn: initSlackMessagePayload,
      name: "SlackMessagePayload",
      fields: [
        {
          name: "recipient",
          property: "recipient",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "message_text",
          property: "messageText",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "urgency",
          property: "urgency",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmUpdateApplyOutcome,
      name: "CrmUpdateApplyOutcome",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "APPLIED",
          number: 1,
        },
        {
          name: "CONFLICT",
          number: 2,
        },
        {
          name: "REJECTED",
          number: 3,
        },
        {
          name: "FAILED",
          number: 4,
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmUpdatePayload,
      initFn: initCrmUpdatePayload,
      name: "CrmUpdatePayload",
      fields: [
        {
          name: "entity_type",
          property: "entityType",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "entity_id",
          property: "entityId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "entity_name",
          property: "entityName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "field_updates_json",
          property: "fieldUpdatesJson",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "rationale",
          property: "rationale",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "api_slug",
          property: "apiSlug",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "previous_value",
          property: "previousValue",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "field_name",
          property: "fieldName",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "field_type",
          property: "fieldType",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "choices_json",
          property: "choicesJson",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "instructions",
          property: "instructions",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "write_mode",
          property: "writeMode",
          number: 11,
          type: {
            kind: "record",
            ctor: x_crm.CustomFieldWriteMode,
          },
        },
        {
          name: "confidence",
          property: "confidence",
          number: 12,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "source_type",
          property: "sourceType",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source_id",
          property: "sourceId",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source_label",
          property: "sourceLabel",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evidence_excerpt",
          property: "evidenceExcerpt",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "applied_at",
          property: "appliedAt",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "applied_by",
          property: "appliedBy",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "applied_value",
          property: "appliedValue",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "discarded_at",
          property: "discardedAt",
          number: 20,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "discarded_by",
          property: "discardedBy",
          number: 21,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source_date",
          property: "sourceDate",
          number: 22,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "superseded_at",
          property: "supersededAt",
          number: 23,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingProposalPayload,
      initFn: initMeetingProposalPayload,
      name: "MeetingProposalPayload",
      fields: [
        {
          name: "participants",
          property: "participants",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableParticipants",
        },
        {
          name: "suggested_slots",
          property: "suggestedSlots",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableSuggestedSlots",
        },
        {
          name: "duration_minutes",
          property: "durationMinutes",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "scheduling_link",
          property: "schedulingLink",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "availability_summary",
          property: "availabilitySummary",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: DocumentReferencePayload,
      initFn: initDocumentReferencePayload,
      name: "DocumentReferencePayload",
      fields: [
        {
          name: "doc_title",
          property: "docTitle",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "doc_url",
          property: "docUrl",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "relevant_excerpt",
          property: "relevantExcerpt",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "why_relevant",
          property: "whyRelevant",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: SubTaskPayload,
      initFn: initSubTaskPayload,
      name: "SubTaskPayload",
      fields: [
        {
          name: "title",
          property: "title",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "priority",
          property: "priority",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "category",
          property: "category",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "deadline",
          property: "deadline",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: SuggestedAction,
      createValueFn: createValueOfSuggestedAction,
      name: "SuggestedAction",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "email_draft",
          number: 1,
          type: {
            kind: "record",
            ctor: EmailDraftPayload,
          },
        },
        {
          name: "slack_message",
          number: 2,
          type: {
            kind: "record",
            ctor: SlackMessagePayload,
          },
        },
        {
          name: "crm_update",
          number: 3,
          type: {
            kind: "record",
            ctor: CrmUpdatePayload,
          },
        },
        {
          name: "meeting_proposal",
          number: 4,
          type: {
            kind: "record",
            ctor: MeetingProposalPayload,
          },
        },
        {
          name: "document_reference",
          number: 5,
          type: {
            kind: "record",
            ctor: DocumentReferencePayload,
          },
        },
        {
          name: "sub_task",
          number: 6,
          type: {
            kind: "record",
            ctor: SubTaskPayload,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: TodoSnapshot,
      initFn: initTodoSnapshot,
      name: "TodoSnapshot",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "title",
          property: "title",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "priority",
          property: "priority",
          number: 3,
          type: {
            kind: "record",
            ctor: TodoPriority,
          },
        },
        {
          name: "category",
          property: "category",
          number: 4,
          type: {
            kind: "record",
            ctor: TodoCategory,
          },
        },
        {
          name: "status",
          property: "status",
          number: 5,
          type: {
            kind: "record",
            ctor: TodoStatus,
          },
        },
        {
          name: "deadline",
          property: "deadline",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "confidence",
          property: "confidence",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
        {
          name: "source_event_type",
          property: "sourceEventType",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source_event_id",
          property: "sourceEventId",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "execution_action",
          property: "executionAction",
          number: 12,
          type: {
            kind: "record",
            ctor: ExecutionAction,
          },
        },
        {
          name: "execution_details",
          property: "executionDetails",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "suggested_actions",
          property: "suggestedActions",
          number: 14,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: SuggestedAction,
            },
          },
          mutableGetter: "mutableSuggestedActions",
        },
        {
          name: "reasoning",
          property: "reasoning",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "parent_todo_id",
          property: "parentTodoId",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_account_id",
          property: "crmAccountId",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "crm_account_name",
          property: "crmAccountName",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_account_domain",
          property: "crmAccountDomain",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_opportunity_id",
          property: "crmOpportunityId",
          number: 20,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "crm_opportunity_name",
          property: "crmOpportunityName",
          number: 21,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "related_meeting_id",
          property: "relatedMeetingId",
          number: 22,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "related_contact_email",
          property: "relatedContactEmail",
          number: 23,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "related_opportunity_remote_id",
          property: "relatedOpportunityRemoteId",
          number: 24,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "assignee_user_id",
          property: "assigneeUserId",
          number: 25,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_user_id",
          property: "ownerUserId",
          number: 26,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_contact_id",
          property: "crmContactId",
          number: 27,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "crm_contact_name",
          property: "crmContactName",
          number: 28,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
      removedNumbers: [
        10,
      ],
    },
  ]
);
